<header>
    <div class="icon-back" (click)="onHeaderBack()" role="button" tabindex="0" aria-label="Volver">
        <mat-icon>arrow_back</mat-icon>
    </div>
    <p class="header-tittle">{{ headerTitle }}</p>
</header>
<app-navigation *ngIf="!isBioFlowActive" [currentStep]="5" [countSteppers]="7"></app-navigation>

<div class="bio-identity-shell" *ngIf="bioFaceStageActive; else identityStage">
    <app-bio-face-flow [initResponse]="bioInitResponse" (validationResult)="onBioValidationResult($event)" (completed)="onBioFaceCompleted($event)" (exit)="back()" (finalError)="onBioFaceFinalError()"></app-bio-face-flow>
</div>

<ng-template #identityStage>
<div class="bio-identity-shell" *ngIf="isIdentityStageActive; else documentsStage">
    <app-bio-document-flow (completed)="onBioIdentityCompleted($event)" (validationResult)="onBioValidationResult($event)" (exit)="back()" (initCompleted)="onBioInitCompleted($event)" (journeyTerminated)="onBioDocumentJourneyTerminated()"></app-bio-document-flow>
</div>
</ng-template>

<ng-template #documentsStage>
<form class="layout-form" [formGroup]="documentForm" >
    <div class="component-content">
        <div class="header-text-container">
            <span class="header-text">Cargá una copia digital de los siguientes documentos.
            </span>
            <br>
            <span class="format-text">Formatos permitidos:.png, .jpeg, .jpg, .pdf. Máximo 20 MB
            </span>
          </div>
        <div class="scroll-display" (scroll)="onScroll($event)">
        <div class="form-select-content">
            <div *ngFor="let file of files; let i = index" [class.bio-hidden-row]="isBioManagedKey(file.key)" >
                <app-file-upload-component *ngIf="!isBioManagedKey(file.key)" [labelText]="file.label" [subtitle]="file.subtitle" [required]="file.required" [submitted]="submitted" [oneFile]="file.oneFile" [documentId]="file.documentId" [isImg]="file.isImg" [ocrValidation]="file.ocrValidation"
                [extensions]="file.extensions" [formControlName]="file.key"  [maxSizeFile]="file.size" [id]="i === 0 ? 'dni-front-upload' : i === 1 ? 'dni-back-upload' : 'file' + i" ></app-file-upload-component>
                <div *ngIf="this.infoTax?.infoAfip?.SH && calculateButton(i)">
                    <a  mat-raised-button class="next-button next-button__60" (click)="addDniSh()" >
                        Agregar Socio</a>
                </div>
                <div  *ngIf="i == 1 && ocrError">
                    <label class="warning-label" >No fue posible validar el DNI. Por favor, adjunte nuevamente la imagen del dorso</label>
                </div>
            </div>
        </div>
    </div>
    </div>

</form>
<div class="privacity-container">
    <div class="privacy-icon" >
        <mat-icon >lock</mat-icon>
    </div>
    <p class="privacity-text">
        Tus documentos son confidenciales y se utilizan únicamente para el proceso de validación.
    </p>

</div>
<!-- Footer -->

<div class="button-container">
    <button id="upload-continue-button" mat-raised-button class="next-button" type="button" (click)="onSubmit()">Continuar</button>
</div>
</ng-template>
  